import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserPropertiesFilteredQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.User_Properties_Bool_Exp>;
}>;


export type GetUserPropertiesFilteredQuery = { __typename?: 'query_root', user_properties: Array<{ __typename?: 'user_properties', id: any, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, premium?: boolean | null, tier_status?: string | null, workspace_id?: any | null, photo_link?: string | null, organization_id: any, warranty_expiration_date?: any | null, warranty_start_date?: any | null, warranty_document_id?: any | null, building_type?: string | null, expected_device_type?: any | null, created_at?: any | null, updated_at?: any | null, partition_id?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, contact_name?: string | null, email?: string | null, type?: string | null } | null, property_contacts: Array<{ __typename?: 'property_contacts', id: any, name?: string | null, number?: string | null, email?: string | null }> } | null }> };


export const GetUserPropertiesFilteredDocument = gql`
    query getUserPropertiesFiltered($where: user_properties_bool_exp) {
  user_properties(where: $where, order_by: {property: {name: asc}}) {
    id
    property {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      premium
      tier_status
      workspace_id
      photo_link
      organization_id
      warranty_expiration_date
      warranty_start_date
      warranty_document_id
      building_type
      expected_device_type
      created_at
      updated_at
      partition_id
      organization_id
      organization {
        id
        name
        contact_name
        email
        type
      }
      property_contacts {
        id
        name
        number
        email
      }
    }
  }
}
    `;

/**
 * __useGetUserPropertiesFilteredQuery__
 *
 * To run a query within a React component, call `useGetUserPropertiesFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPropertiesFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPropertiesFilteredQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUserPropertiesFilteredQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPropertiesFilteredQuery, GetUserPropertiesFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPropertiesFilteredQuery, GetUserPropertiesFilteredQueryVariables>(GetUserPropertiesFilteredDocument, options);
      }
export function useGetUserPropertiesFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPropertiesFilteredQuery, GetUserPropertiesFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPropertiesFilteredQuery, GetUserPropertiesFilteredQueryVariables>(GetUserPropertiesFilteredDocument, options);
        }
export function useGetUserPropertiesFilteredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPropertiesFilteredQuery, GetUserPropertiesFilteredQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPropertiesFilteredQuery, GetUserPropertiesFilteredQueryVariables>(GetUserPropertiesFilteredDocument, options);
        }
export type GetUserPropertiesFilteredQueryHookResult = ReturnType<typeof useGetUserPropertiesFilteredQuery>;
export type GetUserPropertiesFilteredLazyQueryHookResult = ReturnType<typeof useGetUserPropertiesFilteredLazyQuery>;
export type GetUserPropertiesFilteredSuspenseQueryHookResult = ReturnType<typeof useGetUserPropertiesFilteredSuspenseQuery>;
export type GetUserPropertiesFilteredQueryResult = Apollo.QueryResult<GetUserPropertiesFilteredQuery, GetUserPropertiesFilteredQueryVariables>;